import {
  DELETE_REPORT,
  DELETE_REPORT_FAIL,
  DELETE_REPORT_SUCCESS,
  GENERATE_REPORT,
  GENERATE_REPORT_FAIL,
  GENERATE_REPORT_SUCCESS,
  GET_REFIENED_PROGRESS_NOTES_LIST,
  GET_REFIENED_PROGRESS_NOTES_LIST_FAIL,
  GET_REFIENED_PROGRESS_NOTES_LIST_SUCCESS,
  GET_REPORT_LOGS,
  GET_REPORT_LOGS_FAIL,
  GET_REPORT_LOGS_SUCCESS,
  OPEN_AI_REFINE_TEXT,
  OPEN_AI_REFINE_TEXT_FAIL,
  OPEN_AI_REFINE_TEXT_SUCCESS,
  STORE_REFINED_TEXT,
  STORE_REFINED_TEXT_FAIL,
  STORE_REFINED_TEXT_SUCCESS,
  UPDATE_REPORT,
  UPDATE_REPORT_FAIL,
  UPDATE_REPORT_SUCCESS,
  APPROVE_REPORT,
  APPROVE_REPORT_FAIL,
  APPROVE_REPORT_SUCCESS,
  REPORT_ATTACHMENT_LIST,
  REPORT_ATTACHMENT_LIST_SUCCESS,
  REPORT_ATTACHMENT_LIST_FAIL,
  SAVE_REPORT_ATTACHMENT,
  SAVE_REPORT_ATTACHMENT_SUCCESS,
  SAVE_REPORT_ATTACHMENT_FAIL,
  DELETE_REPORT_ATTACHMENT,
  DELETE_REPORT_ATTACHMENT_SUCCESS,
  DELETE_REPORT_ATTACHMENT_FAIL,
  GET_TASK_REPORT_DETAIL,
  GET_TASK_REPORT_DETAIL_SUCCESS,
  GET_TASK_REPORT_DETAIL_FAIL,
  SET_REPORT_PAGINATION,
} from "./actionTypes";

export const approveReport = (data = {}, onSuccess = () => {}, onError = () => {}, dispatch) => ({
  type: APPROVE_REPORT,
  payload: { data, onSuccess, onError, dispatch },
});

export const approveReportSuccess = (data = {}) => ({
  type: APPROVE_REPORT_SUCCESS,
  payload: data,
});

export const approveReportFail = (data = {}) => ({
  type: APPROVE_REPORT_FAIL,
  payload: data,
});

export const participantTaskReport = (data = {}, onSuccess = () => {}, onError = () => {}, dispatch) => ({
  type: GET_TASK_REPORT_DETAIL,
  payload: { data, onSuccess, onError, dispatch },
});

export const participantTaskReportSuccess = (data = {}) => ({
  type: GET_TASK_REPORT_DETAIL_SUCCESS,
  payload: data,
});

export const participantTaskReportFail = (data = {}) => ({
  type: GET_TASK_REPORT_DETAIL_FAIL,
  payload: data,
});

export const deleteReportAttachments = (data = {}, onSuccess = () => {}, onError = () => {}, dispatch) => ({
  type: DELETE_REPORT_ATTACHMENT,
  payload: { data, onSuccess, onError, dispatch },
});

export const deleteReportAttachmentsSuccess = (data = {}) => ({
  type: DELETE_REPORT_ATTACHMENT_SUCCESS,
  payload: data,
});

export const deleteReportAttachmentsFail = (data = {}) => ({
  type: DELETE_REPORT_ATTACHMENT_FAIL,
  payload: data,
});

export const saveReportAttachments = (data = {}, onSuccess = () => {}, onError = () => {}, dispatch) => ({
  type: SAVE_REPORT_ATTACHMENT,
  payload: { data, onSuccess, onError, dispatch },
});

export const saveReportAttachmentsSuccess = (data = {}) => ({
  type: SAVE_REPORT_ATTACHMENT_SUCCESS,
  payload: data,
});

export const saveReportAttachmentsFail = (data = {}) => ({
  type: SAVE_REPORT_ATTACHMENT_FAIL,
  payload: data,
});

export const reportAttachmentList = (data = {}, onSuccess = () => {}, onError = () => {}, dispatch) => ({
  type: REPORT_ATTACHMENT_LIST,
  payload: { data, onSuccess, onError, dispatch },
});

export const reportAttachmentListSuccess = (data = {}) => ({
  type: REPORT_ATTACHMENT_LIST_SUCCESS,
  payload: data,
});

export const reportAttachmentListFail = (data = {}) => ({
  type: REPORT_ATTACHMENT_LIST_FAIL,
  payload: data,
});

export const generateReport = (data = {}, onSuccess = () => {}, onError = () => {}, dispatch) => ({
  type: GENERATE_REPORT,
  payload: { data, onSuccess, onError, dispatch },
});

export const generateReportSuccess = (data = {}) => ({
  type: GENERATE_REPORT_SUCCESS,
  payload: data,
});

export const generateReportFail = (data = {}) => ({
  type: GENERATE_REPORT_FAIL,
  payload: data,
});

export const refineText = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: OPEN_AI_REFINE_TEXT,
  payload: { data, onSuccess, onError },
});

export const refineTextSuccess = (data = {}) => ({
  type: OPEN_AI_REFINE_TEXT_SUCCESS,
  payload: data,
});

export const refineTextFail = (data = {}) => ({
  type: OPEN_AI_REFINE_TEXT_FAIL,
  payload: data,
});

export const storeRefinedText = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: STORE_REFINED_TEXT,
  payload: { data, onSuccess, onError },
});

export const storeRefinedTextSuccess = (data = {}) => ({
  type: STORE_REFINED_TEXT_SUCCESS,
  payload: data,
});

export const storeRefinedTextFail = (data = {}) => ({
  type: STORE_REFINED_TEXT_FAIL,
  payload: data,
});

export const getNotesList = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_REFIENED_PROGRESS_NOTES_LIST,
  payload: { data, onSuccess, onError },
});

export const getNotesListSuccess = (data = {}) => ({
  type: GET_REFIENED_PROGRESS_NOTES_LIST_SUCCESS,
  payload: data,
});

export const getNotesListFail = (data = {}) => ({
  type: GET_REFIENED_PROGRESS_NOTES_LIST_FAIL,
  payload: data,
});

export const updateReport = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: UPDATE_REPORT,
  payload: { data, onSuccess, onError },
});

export const updateReportSuccess = (data = {}) => ({
  type: UPDATE_REPORT_SUCCESS,
  payload: data,
});

export const updateReportFail = (data = {}) => ({
  type: UPDATE_REPORT_FAIL,
  payload: data,
});

export const deleteReport = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: DELETE_REPORT,
  payload: { data, onSuccess, onError },
});

export const deleteReportSuccess = (data = {}) => ({
  type: DELETE_REPORT_SUCCESS,
  payload: data,
});

export const deleteReportFail = (data = {}) => ({
  type: DELETE_REPORT_FAIL,
  payload: data,
});

export const getReportLogs = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_REPORT_LOGS,
  payload: { data, onSuccess, onError },
});

export const getReportLogsSuccess = (data = {}) => ({
  type: GET_REPORT_LOGS_SUCCESS,
  payload: data,
});

export const getReportLogsFail = (data = {}) => ({
  type: GET_REPORT_LOGS_FAIL,
  payload: data,
});

export const setReportPagination = (data = {}) => {
  return {
    type: SET_REPORT_PAGINATION,
    payload: data,
  };
};
